import type {CSSProperties} from 'react';

export type WedgeBv2TabRowsLook = 'bv2tab-pushback';

const BV2_TAB_ROWS_LOOKS = new Set<string>(['bv2tab-pushback']);
export const isWedgeBv2TabRowsLook = (look: string | undefined): look is WedgeBv2TabRowsLook => look !== undefined && BV2_TAB_ROWS_LOOKS.has(look);

/* Released brief v2 tab pushback toggle (prep-brief-v2-tabs, Bv2tPushbackCard). It is a full width row, at least 44px tall, with 16px of
   padding, a flex row of badge, quote, severity and sign, a bare fill and no border. The font face comes from the tab, so the caller passes
   it as style. The look holds the geometry in the declaration order of the source. It draws no transparent target and no anchor
   (wedgeBv2TabRowsDrawsHit): its own box already meets the 44px target size and spans the row. */
export const wedgeBv2TabRowsDrawsHit = (look: string): boolean => !isWedgeBv2TabRowsLook(look);

export function wedgeBv2TabRowsStyle(look: WedgeBv2TabRowsLook): CSSProperties {
  switch (look) {
    case 'bv2tab-pushback': return {
      width: '100%', minHeight: 44, padding: 16, display: 'flex', alignItems: 'center',
      gap: 12, textAlign: 'left', background: 'transparent', border: 0, cursor: 'pointer',
      boxSizing: 'border-box',
    };
  }
}
